// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SectionTitle_wrapper__xi1IC","title":"SectionTitle_title__Ij_El","view_center":"SectionTitle_view_center__WUR6a","view_right":"SectionTitle_view_right__BSSZa"};